webpackJsonp([13578035266858],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/vercel/path0/node_modules/babel-preset-react-app/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/react-hot-loader/babel.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/coi-policy.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  h2 {\n    margin-left: -1.5rem;\n    font-size: 1.5rem;\n    padding-top: .5rem;\n    padding-bottom: 1.5rem;\n  }\n"], ["\n  h2 {\n    margin-left: -1.5rem;\n    font-size: 1.5rem;\n    padding-top: .5rem;\n    padding-bottom: 1.5rem;\n  }\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectors = __webpack_require__("./src/selectors.js");
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _Background = __webpack_require__("./src/components/blocks/Background.js");
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _Post = __webpack_require__("./src/components/Post.js");
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CoiBody = _Post.PostBody.extend(_templateObject);
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var content = (0, _selectors.getGraphNode)(data, "Legal");
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: "Contraline COI Policy",
	        meta: [{ name: "Contraline", content: "COI Policy" }]
	      },
	      _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default })
	    ),
	    _react2.default.createElement(_NavBar2.default, { color: "dark", background: "white" }),
	    _react2.default.createElement(
	      _Background2.default,
	      { color: "white", fixed: true },
	      _react2.default.createElement(
	        _Section2.default,
	        { noBorder: true, fixed: true, vPad: false },
	        _react2.default.createElement(_Spacer2.default, { span: 2 }),
	        _react2.default.createElement(
	          _Pad2.default,
	          { h: 2 },
	          _react2.default.createElement(
	            _Pad2.default,
	            { h: 5, v: 1 },
	            _react2.default.createElement(
	              _typography.H3,
	              null,
	              "COI Policy"
	            )
	          ),
	          _react2.default.createElement(
	            CoiBody,
	            null,
	            _react2.default.createElement(_reactMarkdown2.default, { source: content.coiPolicy.coiPolicy })
	          )
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 2 })
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-coi-policy-js-6c74419d8d38176556f5.js